import type { DaforgeRelease } from '../data/daforge-data';
import { caseIndex } from '../data/daforge-data';
import type { TestResultData } from '../hooks/useTestResults';

function escapeCSV(value: string): string {
  if (!value) return '""';
  if (/[",\n;]/.test(value)) return `"${value.replace(/"/g, '""')}"`;
  return value;
}

/**
 * Jegyzőkönyv: tesztesetenként ÉS tesztelőnként egy sor; a még senki által nem
 * tesztelt eset egy `not_tested` sort kap, hogy a hiány is látsszon.
 * UTF-8 BOM az Excel ékezet-kezeléséhez.
 */
export function generateDaforgeCsv(rel: DaforgeRelease, results: TestResultData[]): string {
  const headers = [
    'Kiadás',
    'Változás',
    'Terület',
    'Teszteset',
    'Teszteset címe',
    'Állapot',
    'Tesztelő',
    'Megjegyzés',
    'Időpont',
  ];
  const changeById = new Map(rel.changes.map(c => [c.id, c]));
  const rows: string[] = [];
  for (const c of rel.cases) {
    const ch = changeById.get(c.change);
    const idx = caseIndex(c.id);
    const mine = results.filter(r => r.featureIndex === idx);
    const base = [rel.release.id, c.change, escapeCSV(ch?.area ?? ''), c.id, escapeCSV(c.title)];
    if (mine.length === 0) {
      rows.push([...base, 'not_tested', '""', '""', ''].join(','));
      continue;
    }
    for (const r of mine) {
      rows.push(
        [...base, r.status, escapeCSV(r.testerName), escapeCSV(r.comment ?? ''), r.updatedAt].join(
          ','
        )
      );
    }
  }
  return '﻿' + [headers.join(','), ...rows].join('\n');
}
